import { DataBean } from "../DataBean";

export class TechnicianAssignment extends DataBean {

  public async getTechnicianAssignmentCatalogPorPropiedades( properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getTechnicianAssignmentCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getTechnicianAssignmentRender(page: number, rows: number, properties: any, startDate: Date, endDate: Date): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getTechnicianAssignmentRender_Number_Number_java.util.Map_java.util.Date_java.util.Date",
      [page, rows, properties, startDate, endDate]
    );
  }

  public async deleteTechnicianAssignment (idtechnicianassignment: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "boolean_deleteTechnicianAssignment_Number",
      [idtechnicianassignment]
    );
  }

  public async updateTechnicianAssignment(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.TechnicianAssignment_updateTechnicianAssignment_com.orange.finance.processcontract.bean.TechnicianAssignment",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.TechnicianAssignment",
        },
      ]
    );
  }
}
